module.exports = __webpack_public_path__ + "static/media/02290001-TNB0wSgs.e9071acf.JPG";